import { Skeleton } from '@innovamat/glimmer-components';

function EmailPreferencesSkeleton() {
  return (
    <>
      <Skeleton height="32px" width="60%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="32px" width="50%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="32px" width="55%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="64px" width="100%" />
      <Skeleton height="64px" width="100%" />
    </>
  );
}

export { EmailPreferencesSkeleton };
